import * as React from "react";
function SvgIcNext(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6 3.744v16.512l7.83-7.512V21H18V3h-4.17v8.256L6 3.744zM14.83 4v16H17V4h-2.17zm-1.668 8L7 6.09v11.82L13.162 12z"
        fill="currentColor"
      />
    </svg>
  );
}
export default SvgIcNext;
